import request from "./../utils/request";

export function getWelcomeMessages(perpage = 20, page = 1) {
    return request({
        url: `/welcomeMessages/pagination`,
        method: "get",
        params: {
            pageCount: page,
            perPage: perpage,
        },
    });
}

export function createWelcomeMessage(data) {
    return request({
        url: "/welcomeMessages/",
        method: "post",
        data: data,
    });
}

export function updateWelcomeMessage(id, data) {
    return request.put(`/welcomeMessages/${id}`, data);
}

export function deleteWelcomeMessage(id) {
    return request.delete(`/welcomeMessages/${id}`);
}
